import './context/functions/loadAppConfig'
import React from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal'
import { BrowserRouter, Route } from 'react-router-dom'
import 'mapbox-gl/dist/mapbox-gl.css'
// eslint-disable-next-line import/no-unresolved
import '@centivo/provider-directory-components/style.css'

import { GlobalContextProvider } from './context/global'
import { Routes } from './refactor/pages'
import { ModalGlobalStyles } from './refactor/blocks/Modal'
import { MapGlobalStyles } from './refactor/blocks'
import './styles/App.scss'
// import './styles/map.scss'

Modal.setAppElement('#root')

library.add(faArrowRight, faArrowLeft)

const App = () => {
  return (
    <GlobalContextProvider>
      <ModalGlobalStyles />
      <MapGlobalStyles />
      <BrowserRouter>
        <Route component={Routes} />
      </BrowserRouter>
    </GlobalContextProvider>
  )
}

export default App
